// extracted by mini-css-extract-plugin
module.exports = {"Caption":"caption_Caption__10JVT"};